import { render, staticRenderFns } from "./index.vue?vue&type=template&id=549d00e0&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('549d00e0')) {
      api.createRecord('549d00e0', component.options)
    } else {
      api.reload('549d00e0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=549d00e0&", function () {
      api.rerender('549d00e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/supplier-label/index.vue"
export default component.exports